import React, { forwardRef } from 'react';
import MUIChip, { ChipProps } from '@mui/material/Chip';
import CancelIcon from '@mui/icons-material/Cancel';
import styled from '@emotion/styled';
import gradients from '../Theme/gradients';

const Chip = forwardRef<HTMLDivElement, ChipProps>((properties, reference) => (
  <MUIChip ref={reference} {...properties} />
));

interface StyledChipProperties extends ChipProps {
  selected?: boolean;
}

const BaseStyledChip = styled(Chip)`
  font-weight: 500;
  font-size: .75rem;

  &.MuiChip-colorPrimary {
    background-image: linear-gradient(to right, ${gradients.subtle});
  }
`;

export const StyledChip = forwardRef<HTMLDivElement, StyledChipProperties>(
  ({ selected, color, ...properties }, reference) => (
    <BaseStyledChip
      ref={reference}
      color={color ?? (selected ? 'primary' : 'default')}
      {...properties}
    />
  ),
);

const StyledDeletableChip = styled(Chip)`
  font-weight: 500;
  font-size: .75rem;

  &.MuiChip-colorPrimary {
    background-image: linear-gradient(to right, ${gradients.subtle});
  }

  .MuiChip-deleteIcon {
    font-size: 1rem;
    margin-right: 8px;
  }
`;

export const DeletableChip = forwardRef<
  HTMLDivElement,
  ChipProps
>((properties, reference) => (
  <StyledDeletableChip
    ref={reference}
    deleteIcon={
      <CancelIcon titleAccess={`Remove ${String(properties.label)}`} />
    }
    {...properties}
  />
));

export default Chip;
